<script setup>
import config from '@/preload/data/config.json'
import categoryTree from '@/preload/data/categories.json'

defineProps({
  headerHeight: {
    type: Number,
    default: 100,
  }
})

defineEmits(['show:mobile-navigation'])

const filteredTree = useAvailableCategoryTree(categoryTree)
const elevateHeader = ref(false)

function onScroll (e) {
  elevateHeader.value = e.target.documentElement.scrollTop >= 60
}
</script>

<template>
  <v-app-bar
    v-scroll="onScroll"
    :elevation="elevateHeader ? 10 : 0"
    color="white"
    flat
    :height="headerHeight"
    class="app-bar--wrap"
    :class="{
      'border-b': !elevateHeader
    }"
  >
    <v-container>
      <div class="d-flex align-center">
        <NuxtLink
          to="/"
          class="mr-10 logo-wrap"
          :class="{
            'is--fixed': config.fixed_logo,
            'is--fixed-top': config.fixed_logo_at_top,
          }"
          :style="{ width: config.logo_width ? `${config.logo_width}px` : null }"
        >
          <cms-logo :width="config.logo_width || 340" class="header-logo" />
        </NuxtLink>

        <v-spacer />

        <nav-tabs
          :nav-entries="filteredTree"
          :height="headerHeight"
          class="d-none d-lg-block"
        />

        <v-btn
          icon="$menu"
          class="d-lg-none"
          aria-label="Navigation anzeigen"
          @click="$emit('show:mobile-navigation')"
        />

        <a
          href="https://www.gesundistbunt.de"
          target="_blank"
          title="Zu GESUND IST BUNT"
          rel="noopener"
        >
          <img
            src="/img/ico_gib.svg"
            width="40"
            height="32"
            class="ml-4"
            alt="GIB-Icon"
          >
        </a>
      </div>
    </v-container>
  </v-app-bar>
</template>

<style lang="scss">
  .app-bar--wrap {
    .header-logo img {
      display: block;
      max-height: 64px;
      max-width: 100%;
    }

    @media (min-width: 600px) {
      .logo-wrap {
        &.is--fixed {
          display: inline-block;

          .header-logo {
            position: fixed;
            top: 10px;
            z-index: 1;

            img {
              max-height: none;
              object-position: left center;
            }
          }

          &.is--fixed-top {
            .header-logo {
              top: 0;
            }
          }
        }
      }
    }

    @media (min-width: 600px) and (max-width: 1919px) {
      .v-container {
        max-width: 95%;
      }
    }
  }
</style>
